import { createContext } from 'react';

import { INITIAL_STATE } from './constants';
import { IRootContext } from './types';

export const RootContext = createContext<IRootContext>({ ...INITIAL_STATE });

export const RootProvider = RootContext.Provider;
export const RootConsumer = RootContext.Consumer;
